import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../services/ApiService'
import { showAlert } from '../../utility/SweetAlert'

const InteractorStorageView = () => {
  const { t } = useTranslation()

  const storageView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/storage-data/view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
            redirect: '/storage/manage',
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { storageView }
}

export default InteractorStorageView
